export { default } from './BoundedPageTemplate'
